const AUTH_FLOW_ROUTES = new Set(['/login', '/forgot-password', '/reset-password', '/change-password']);

export function safeAuthReturnUrl(
  value: string | null | undefined,
  fallback = '/dashboard',
): string {
  const safeFallback = isProtectedLocalUrl(fallback) ? fallback : '/dashboard';

  return isProtectedLocalUrl(value) ? value : safeFallback;
}

function isProtectedLocalUrl(value: string | null | undefined): value is string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) {
    return false;
  }

  const path = value.split(/[?#]/, 1)[0].replace(/\/$/, '') || '/';

  return !AUTH_FLOW_ROUTES.has(path);
}
